import './App.css';
// import AdminDashboard from './components/DashBoard/AdminDashboard';
// import AdminPanel from './components/Admin/AdminPanel';
// import AdminPropertyForm from './components/DashBoard/AdminPropertyForm';
// import Blogs from './components/other/Blogs';
import Body from './components/other/Body';
// import PropertyPage2 from './components/Property/PropertyPage2';
// import PropertyList from './ui/PropertyList';



function App() {
  return (
    <div className="App">
      <Body />
      {/* <AdminPanel/> */}
      {/* <AdminDashboard/> */}
      {/* <Blogs/> */}
   {/* <AdminPropertyForm/> */}
      {/* <PropertyPage2/>  */}
{/* <PropertyList/> */}
    {/* <PropertyCard dummy={dummy[0]} />    */}
     </div>
  );
}

export default App;
